import { render, staticRenderFns } from "./mailNotification.vue?vue&type=template&id=a64d12c6&scoped=true&"
import script from "./mailNotification.vue?vue&type=script&lang=js&"
export * from "./mailNotification.vue?vue&type=script&lang=js&"
import style0 from "./mailNotification.vue?vue&type=style&index=0&id=a64d12c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64d12c6",
  null
  
)

export default component.exports